module.exports = __webpack_public_path__ + "static/img/t5_1.8f020b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/technology/t5_1.png
// module id = yitl
// module chunks = 0